import { LocalDateTime } from "@js-joda/core";
import * as React from "react";
import { globalize } from "../../../translate";

export interface EditRequestScreenTimeComponentProps {
  scheduledTime: LocalDateTime;
  requestedTime: LocalDateTime;
  title: string;
}

export interface EditRequestScreenTimeComponentState {}

export class EditRequestScreenTimeComponent extends React.Component<
  EditRequestScreenTimeComponentProps,
  EditRequestScreenTimeComponentState
> {
  constructor(props: EditRequestScreenTimeComponentProps) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <div className="EditRequestScreenTimeComponent__requestParamsRoot">
        <b>{this.props.title}</b>
        <div className="EditRequestScreenTimeComponent__requestParamsCol">
          <div
            className={
              this.props.requestedTime === this.props.scheduledTime
                ? "EditRequestScreenTimeComponent__requestParamsRequested"
                : "EditRequestScreenTimeComponent__requestParamsOriginal"
            }
          >
            {globalize().formatLocalDateTime(this.props.scheduledTime, { datetime: "medium" })}
          </div>
          {this.props.requestedTime === this.props.scheduledTime ? (
            ""
          ) : (
            <div>
              <div className="EditRequestScreenTimeComponent__requestArrow" />
              <div className="EditRequestScreenTimeComponent__requestParamsRequested">
                {globalize().formatLocalDateTime(this.props.requestedTime, { datetime: "medium" })}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
